import React, { useContext, useEffect, useRef, useState } from 'react';
import { ToastContext } from 'app/context/ToastContext';
import { Divider } from 'primereact/divider';
import './contract-page.css';
import axios from 'axios';
import { formatDateFromInstant } from 'app/shared/util/date-utils';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

export const ExistingRequestsPage = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fileUploadRef = useRef(null);

  useEffect(() => {
    // Example GET request; adjust URL & structure as needed
    axios
      .get('/api/client-request-message/byType/1?sort=createdDate,desc')
      .then(response => {
        setData(response.data?.content); // response.data should be an array
      })
      .catch(error => {
        console.error('Error fetching sent requests:', error);
        showError('Chyba', error.response?.data?.detail);
      });
  }, []);

  const showExclamation = zaplatene => {
    return zaplatene ? <i className="pi pi-exclamation-triangle" style={{ color: 'red' }}></i> : null;
  };

  const showRequest = req => {
    navigate(`/requests/new/${req.id}`);
  };

  return (
    <div>
      <h1 style={{ color: 'var(--primary-color)' }}>ODOSLANÉ ŽIADOSTI</h1>

      <Divider className="client-divider" />

      <div className="border new-request-container" style={{ borderColor: '#b9985a !important' }}>
        <div className="border" style={{ borderColor: '#b9985a !important' }}>
          <div style={{ backgroundColor: 'var(--primary-color)', padding: '0.5rem' }}>
            <h5 className="mb-0 text-white">ODOSLANÉ ŽIADOSTI</h5>
          </div>

          {/* List of already sent requests */}
          <div className="p-3">
            {data.length > 0 ? (
              data.map((req, index) => (
                <div key={'request-page-id-' + index}>
                  <div
                    key={index}
                    className="border mb-3 p-4 flex items-center justify-between"
                    style={{ borderColor: 'var(--primary-color)' }}
                  >
                    <div>{showExclamation(req.hasUnseen)}</div>

                    <div className="flex-1 text-center" style={{ color: '#666' }}>
                      {req.title && (
                        <b>
                          {req.title}
                          <br />
                        </b>
                      )}
                      {req.message || 'Odoslaná žiadosť dňa: ' + formatDateFromInstant(req.createdDate)}
                    </div>

                    <div>
                      <Button
                        label=""
                        type="button"
                        icon="pi pi-arrow-right"
                        className="p-button-secondary mr-2"
                        style={{ backgroundColor: 'gray' }}
                        onClick={() => showRequest(req)}
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-muted">Žiadne odoslané žiadosti</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExistingRequestsPage;
